import { useEffect } from 'react';
import { useLocation } from 'react-router';

const NotFound = () => {
  const currentLocation = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', currentLocation.pathname);
  }, [currentLocation.pathname]);

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="text-muted-foreground mb-4 text-xl">Oops! Page not found</p>
        <a href="/" className="text-primary hover:text-primary/90 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
